// Copyright (C) 2019 TANNER AG

import React, { useContext } from "react";
import * as PropTypes from "prop-types";
import classnames from "classnames";
import { Table, TableBody, withStyles } from "@material-ui/core";
import { TranslationContext } from "../translation";
import { DefaultParameterRow } from "../defaultparamters/table";
import { format as formatEfficientHybrid } from "../configuration/modules/efficienthybrid";
import { format as formatHoldingPeriod } from "../configuration/modules/holdingperiod";
import { formatMileages } from "../configuration/modules/annualmileage";
import { BusImage } from "../components/busimage";

const styles = {
	container: {
		flexBasis: 0,
		flexGrow: 1,
		width: "100%",
		height: "100%",
		maxWidth: "100%",
		display: "flex",
		justifyContent: "center",
		color: "#303C49",
		opacity: "0.6",
		"&.success": {
			opacity: 1,
			backgroundColor: "#90bb00",
			color: "#fff"
		},
		"&.failed": {
			opacity: 1,
			backgroundColor: "#e40045",
			color: "#fff"
		}
	},
	containerInner: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		margin: "10% 90px",
		width: "100%"
	},
	image: {
		width: 220,
		marginTop: "35px",
		"& > img": {
			width: "100%",
			height: "auto",
			borderRadius: 6,
			boxShadow: "0 1px 1px 0 rgba(0,0,0,0.5)",
			border: "2px solid #fff"
		}
	},
	table: {
		backgroundColor: "#fff",
		borderRadius: 4,
		marginTop: "35px",
		boxShadow: "0 1px 1px 0 rgba(0,0,0,0.5)"
	},
	name: {
		fontFamily: "MANEurope, Arial, sans-serif",
		fontWeight: "bold",
		fontStretch: "condensed",
		fontSize: 22,
		lineHeight: "30px",
		textAlign: "center"
	},
	description: {
		fontFamily: "MANEurope, Arial, sans-serif",
		fontWeight: 300,
		fontSize: 15,
		lineHeight: "22px",
		textAlign: "center"
	},
	message: {
		fontFamily: "MANEurope, Arial, sans-serif",
		fontWeight: 300,
		fontStyle: "normal",
		fontSize: "22px",
		lineHeight: "30px",
		textAlign: "center",
		marginTop: "45px",
		color: "#fff",
		maxWidth: "100%"
	},
	"@global": {
		".result-marker": {
			color: "#000"
		}
	}
};

export const Paper = withStyles(styles)((props) => {
	const { classes, success, variant, percent, data, configuration } = props;
	const { translate, format } = useContext(TranslationContext);
	return (
		<div className={classnames(classes.container, { success })}>
			<div className={classes.containerInner}>
				<div>
					<div className={classes.name}>{data.bus.name}</div>
					<div className={classes.description}>
						{`${data.bus.doors} ${translate("common.doors")}`}, {data.bus.fuel}
					</div>
				</div>
				<div className={classes.image}>
					<BusImage
						fuel={data.bus.fuel}
						type={data.bus.type}
						name={data.bus.name}
					/>
				</div>
				<div className={classes.table}>
					<Table>
						<TableBody>
							<DefaultParameterRow
								name={translate("module.drivingprofile.title")}
								value={data.drivingProfile}
							/>
							<DefaultParameterRow
								name={translate("module.efficienthybrid.title")}
								value={formatEfficientHybrid(data.efficientHybrid, translate) || "–"}
							/>
							<DefaultParameterRow
								name={translate("module.fuelprice.title")}
								value={format(data.fuelPrice, true)}
							/>
							<DefaultParameterRow
								name={translate("module.holdingperiod.title")}
								value={formatHoldingPeriod(data.holdingPeriod, translate)}
							/>
							<DefaultParameterRow
								name={translate("module.annualmileage.title")}
								value={formatMileages(data.annualMileage, translate, format)}
							/>
						</TableBody>
					</Table>
				</div>
				{success && (
					<div
						className={classes.message}
						dangerouslySetInnerHTML={{
							__html: translate(`result.message.${configuration.toLowerCase()}${(variant) ? ".variant" : ""}`, {
								name: data.bus.name,
								percent: format(percent, false, { maximumFractionDigits: 0 })
							})
						}}
					/>
				)}
			</div>
		</div>
	);
});

Paper.propTypes = {
	data: PropTypes.object,
	success: PropTypes.bool,
	percent: PropTypes.number,
	configuration: PropTypes.string,
	variant: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/tco/result/paper.js